import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { UiI18nContext } from "./UiI18nContext";
import { useCimodeLocaleOverride } from "./useCimodeLocaleOverride";
export function useUiTranslator() {
    const i18n = useContext(UiI18nContext);
    const lng = useCimodeLocaleOverride(i18n);
    const { t } = useTranslation(undefined, {
        i18n,
        lng,
    });
    return useCallback((dictionaryKey, defaultValue, options) => t(dictionaryKey, defaultValue, options), [t]);
}
//# sourceMappingURL=useUiTranslator.js.map